import React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from 'layouts/Footer/Footer';
import GraasBetaLogo from 'assets/images/graas_logo_small.svg';
import GraasLogo from  'assets/images/graas_logo_small-old.svg'
import { Space } from 'antd';
import Icon from 'components/Icon';
import SMResult from 'components/Atoms/SMResult/SMResult';
import { delay } from 'lodash-es';
import { useSelector } from 'react-redux';

const ErrorPage = () => {
  const { t } = useTranslation();
  const countryCode = useSelector(state => state?.User?.userData?.countryCode);

  return (
    <>
      <div className='c-pageContainer'>
        <div className='c-pageBody'>
          <div className={`c-contentWrapper`}>
            <header className='c-header'>
              <div className='header_logo'>
                <div className='header_link'>
                  <img className='logo' src={countryCode === 'IN' ? GraasBetaLogo : GraasLogo} alt='graas' />
                </div>
              </div>
              <div className='header_nav'>
                <div className='c-headerMenu'>
                  <a className='headerMenu_item active' href='/analyze/workspace'>
                    {t('GRAAS_ANALYZE_GRAAS')}
                  </a>
                  <a aria-current='page' className='headerMenu_item' href='/connect/'>
                    {t('GRAAS_CONNECT_GRAAS')}
                  </a>
                </div>
              </div>
            </header>
            <section>
              <div className='errorContainer'>
                <div style={{ width: '300px', textAlign: 'center' }}>
                  <SMResult type='loader' size='medium' />
                  <span className='c-heading smm color-light dont-break mb-2'>
                    {t('GRAAS_SOMETHING_WENT_WRONG_GRAAS')}
                  </span>
                  <button
                    className='c-button is-filled'
                    onClick={() => {
                      const location = window.location.href;
                      const isLoginUrl = location?.includes('login');
                      if (process.env.NODE_ENV === 'production' && !isLoginUrl && window?._mfq) {
                        window._mfq?.push(['tag', 'system_page_break_event']);
                      }
                      delay(() => {
                        window.parent.location = window.parent.location.href;
                      }, 100);
                    }}
                  >
                    <Space>
                      <Icon name='refresh' isBordered />
                      {t('GRAAS_RELOAD_PAGE_GRAAS')}
                    </Space>
                  </button>
                </div>
              </div>
            </section>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
